export default "__VITE_ASSET__BnRRBaQV__"